
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/post/[postId]",
      function () {
        return require("private-next-pages/blog/post/[postId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/post/[postId]"])
      });
    }
  